/*
 * The texts of the map extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		map: {
			show: 'Auf Karte zeigen',
			route: 'Route planen',
			locate: 'Standort ermitteln',
			clear: 'Standort löschen',
			zoom_in: 'Vergrößern',
			zoom_out: 'Verkleinern',
			north: 'Nach Norden ausrichten',
			fit: 'Alles anzeigen',
			entities_smaller: 'Symbole verkleinern',
			entities_bigger: 'Symbole vergrößern',
			layers: 'Ebenen',
			color: 'Farbig anzeigen',
			grayscale: 'Graustufen anzeigen',
			save: 'Karte speichern',
			upload: 'Karte hochladen',
			calculate: 'Transformation berechnen',
			layer_create: 'Ebene anlegen',
			layer_edit: 'Ebene bearbeiten',
			layer_delete: 'Ebene löschen',
			layer_detail: 'Detailstufe hinzufügen',
			layer_zoom: 'Auf Ebene zoomen',
			overlay_create: 'Overlay anlegen',
			overlay_edit: 'Overlay bearbeiten',
			overlay_delete: 'Overlay löschen',
			marker_create: 'Marker anlegen',
			marker_edit: 'Marker bearbeiten',
			marker_delete: 'Marker löschen',
		},
	},
	pages: {
		map: {
			context_menu: {
				center: 'Hier zentrieren',
				copy_coordinates: 'Koordinaten kopieren',
			},
		},
	},
	sidebar: {
		map: 'Karte',
	},
	modals: {
		edit_event_layer: {
			create: 'Neuen Layer erstellen',
			edit: 'Layer bearbeiten',
		},
		edit_event_overlay: {
			create: 'Neues Overlay erstellen',
			edit: 'Overlay bearbeiten',
		},
		remove_event_layer: {
			title: 'Karten Layer löschen',
			text: "Soll der Karten Layer '{item}' wirklich gelöscht werden?",
		},
		edit_marker: {
			create: 'Neue Markierung erstellen',
			edit: 'Markierung bearbeiten',
		},
		remove_marker: {
			title: 'Markierung löschen',
			text: "Soll die Markierung '{item}' wirklich gelöscht werden?",
		},
	},
	confirms: {
		remove_event_overlay: {
			title: 'Overlay löschen',
			text: 'Soll des Overlay "{name}" wirklich entfernt werden?',
		},
	},
	data: {
		event_layer: {
			name: 'Name',
			opacity: 'Deckkraft',
			is_grayscale: 'Graustufen',
			transformation: {
				a0: 'a0',
				b0: 'b0',
				a1: 'a1',
				b1: 'b1',
				a2: 'a2',
				b2: 'b2',
			},
		},
		event_overlay: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			url: 'Url',
			layer: 'Layer',
			format: 'Format',
			opacity: 'Transparenz',
			minZoom: 'Zoom Faktor',
		},
		marker: {
			id: 'Id',
			name: 'Name',
			icon: 'Symbol',
			coordinates: 'Koordinaten',
			description: 'Beschreibung',
		},
	},
	enums: {
		crs: {
			'null': '-',
			'EPSG:4326': 'WGS84 (GPS)',
			'EPSG:3857': 'Webmercator',
			'EPSG:25832': 'UTM Zone 32N',
			'EPSG:25833': 'UTM Zone 33N',
		},
	},
	tabs: {
		context_settings: {
			groups: {
				map: 'Karte',
			},
			map: 'Karte',
			markers: 'Markierungen',
		},
		event_settings: {
			map: 'Karte',
			markers: 'Markierung',
		},
	},
};
